import './plugins/webPushNotification'

setInterval(() => {
    const heading = document.querySelector('[data-role="heading"]');
    if(heading){
        heading.dataset.state = heading.dataset.state === 'kazakh' ? 'russian' : 'kazakh';
    }
}, 3000)

